<h1>
  @for (part of parts; track $index) {
    @if (part.bold) {
      <b>{{ part.text }}</b>
    } @else {
      <span>{{ part.text }}</span>
    }
  }
</h1>
